import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
import RadioGroup from "../../components/Reports/RadioGroup";
import { useEffect, useRef, useState } from "react";
import {
  DOMESTIC,
  NOTRANSACTION,
  OFFSHORE,
  homePageRoute,
  oneDayDif,
  PORTFOLIO,
  portfolioReportMsg,
  portfolioReportType,
  portfolioReportValues,
  REPORTS_PAGE,
  timePeriodRadioBtnsData,
} from "../../utils/constants";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import FilledButton from "../../components/SelectButton/FilledButton";
import EmptyButton from "../../components/SelectButton/EmptyButton";
import Modal from "../../components/Modal";
import emailSuccess from "../../assets/images/svg/emailSuccess.svg";
import homeBtnIcon from "../../assets/images/svg/homeBtnIcon.svg";
import { ReactComponent as ExcelFilledWhite } from "../../assets/images/svg/execelFilledWhite.svg";
import { ReactComponent as PdfFilledWhite } from "../../assets/images/svg/pdfFilledWhite.svg";
import { ReactComponent as EmailFilledWhite } from "../../assets/images/svg/emailFilledWhite.svg";
import ArrowButton from "../../components/ArrowButton";
import BlueButton from "../../components/Reports/BlueButton";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import {
  convertDateToObj,
  getAsOfDate,
  getDecodedToken,
  getExcelPdfNamePortfolio,
  logEvents,
  getNameForPortfolioReportExcel,
  padNumber,
  trackEventWithScreen,
  getReportType,
  getOffshoreData,
  getCurrentDateAndTimeDDMMYYHHMM,
} from "../../utils/functions";
import transectionReportIcon from "../../assets/images/svg/tranReportIcon.svg";
import unrealisedReportIcon from "../../assets/images/svg/unrealisedReportIcon.svg";
import taxReportIcon from "../../assets/images/svg/taxReportIcon.svg";
import { useNavigate } from "react-router";
import DatePicker2 from "../../components/Reports/DatePicker2";
import ModalFamily from "../../components/ModalFamily/ModalFamily";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { setCookie, getCookie } from "../../utils/cookie";
//import OverflowingText from "../../components/OverflowingText/OverflowingText";
import { useMemo } from "react";
import Skeleton from "react-loading-skeleton";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import AccountsDropDown from "../../components/Reports/UnrealisedGLReport/AccountsDropDown";
import AcquisitionDateTypeDropdown from "../../components/Reports/PortfolioReport/AcquisitionDateTypeDropdown";
//import OverflowingText from "../../components/OverflowingText/OverflowingText";
import ReportTypeDropdown from "../../components/Reports/PortfolioReport/ReportTypeDropdown";

const trasnfArr = ["Transfer-In Date", "Inception Date"];
const inceptionArr = ["Inception Date", "Transfer-In Date"];

const PortfolioReport = observer(() => {
  const loaderRef = useRef(null);
  const reportTypeRef = useRef(null);

  const [timePeriod, setTimePeriod] = useState(
    UserStore.portfolioReportFilter.timePeriod,
  );
  const [denomination, setDenomination] = useState(
    UserStore.portfolioReportFilter.denomination,
  );
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [allMembersMenuOpen, setAllMembersMenuOpen] = useState(false);
  // const [allAccountsMenuOpen, setAllAccountsMenuOpen] = useState(false);
  // const [acquisitionDateMenuOpen, setAcquisitionDateMenuOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(
    UserStore.portfolioReportFilter.selectedMember,
  );
  const [selectedAccount, setSelectedAccount] = useState(
    UserStore.portfolioReportFilter.selectedAccount,
  );
  const [selectedAcquisitionDate, setSelectedAcquisitionDate] = useState(
    UserStore.portfolioReportFilter.selectedAcquisitionDate,
  );
  const [reportTypeOptions, setReportTypeOptions] = useState({
    type: null,
    isCombined: false,
  });

  //const [isReportTypeMenuOpen, setIsReportTypeMenuOpen] = useState(false);
  const [emailReportSuccessOpen, setEmailReportSuccessOpen] = useState(false);
  const [emailReportToOpen, setEmailReportToOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(
    getDecodedToken()?.user_type === "employee" ? "selfEmail" : "clientEmail",
  );
  const [isSort, setSort] = useState("asc");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [Checkboxes, setCheckBoxes] = useState(
    UserStore.portfolioReportFilter.selectedSection,
  );
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSendingMail, setIsSendingMail] = useState(false);

  const navigate = useNavigate();

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };
  const handleDenominationChange = (selectedDenomination) => {
    setDenomination(selectedDenomination);
  };

  const userHydrated = UserStore.isHydrated;
  const portfolioFilter = UserStore.portfolioReportFilter;

  useEffect(() => {
    if (UserStore.isHydrated) {
      // Set default selected report type on first time load (key either isoffshore or isoffshore family , that depends on the whole family or client is selected)

      const offshoreValue = getReportType(
        UserStore.portfolioReportFilter,
        UserStore.userData,
      );

      setReportTypeOptions((prev) => ({
        ...prev,
        type: portfolioReportValues[offshoreValue],
        isCombined: offshoreValue === 2,
      }));

      setDenomination(UserStore.portfolioReportFilter.denomination);
      setCheckBoxes(UserStore.portfolioReportFilter.selectedSection);
      setSelectedMember(UserStore.portfolioReportFilter.selectedMember);
      setSelectedAccount(UserStore.portfolioReportFilter.selectedAccount);
      setTimePeriod(UserStore.portfolioReportFilter.timePeriod);
    }
  }, [userHydrated, portfolioFilter]);

  const EmailReportSuccessContent = () => {
    return (
      <div className="email_success_container">
        <img
          className="email_success_img"
          src={emailSuccess}
          alt="email succes"
        />
        <p className="email_success_msg">
          Your report has been emailed to the registered Email ID
        </p>
        <div
          className="email_success_home_btn_wrapper"
          onClick={() => {
            const { isOffshoreOnly, navigateTo } = getOffshoreData();

            navigate(navigateTo, {
              state: isOffshoreOnly ? { from: OFFSHORE } : {},
            });
          }}
        >
          <p className="back_to_home_text">Back to Home</p>
          <button>
            <img src={homeBtnIcon} alt={homePageRoute} />
          </button>
        </div>
      </div>
    );
  };

  const EmailReportToContent = useMemo(() => {
    const emailReportToData = [
      {
        id: "selfEmail",
        title: "Self",
      },
      {
        id: "csoEmail",
        title: "CXO",
      },
      {
        id: "rmEmail",
        title: "RM",
      },
      {
        id: "clientEmail",
        title: "Client",
      },
    ];
    const handleChange = (id) => {
      setSelectedUser(id);
    };

    const handleReset = () => {
      setSelectedUser("selfEmail");
    };

    return (
      <div className="email_report_to_container">
        <div className="radio_btn_options_wrapper">
          {isSendingMail && (
            <div className="email_report_to_loader_container">
              <img className="loader_gif" src={loaderGIF} alt="loading..." />
            </div>
          )}

          {emailReportToData.map((userData) => (
            <div
              className="radio_btn_option cursor"
              onClick={() => handleChange(userData.id)}
            >
              <button
                className="radio_btn_input"
                onClick={() => handleChange(userData.id)}
              >
                {userData.id === selectedUser ? (
                  <FilledButton />
                ) : (
                  <EmptyButton />
                )}
              </button>
              <label className="radio_btn_label" for={userData.id}>
                {userData?.title}
              </label>
            </div>
          ))}
        </div>
        <div className="confirm_email_wrapper">
          <p className="confirm_email_text">Confirm Email ID</p>
          <p className="user_email">
            {ReportsStore.emailIdDataForPortfolio?.[selectedUser] || "-"}
          </p>
        </div>
        <div className="footer_reset_apply_wrapper">
          <button className="reset_btn" onClick={handleReset}>
            <p className="reset_text">Reset</p>
          </button>

          <ArrowButton
            type="next"
            label="Apply"
            onClick={() => sendEmail("btn", reportTypeOptions)}
          />
        </div>
      </div>
    );
  }, [
    selectedUser,
    ReportsStore.emailIdDataForPortfolio?.[selectedUser],
    selectedMember,
    selectedAccount,
    denomination,
    selectedAcquisitionDate,
    Checkboxes,
    fromDate,
    toDate,
    isSendingMail,
  ]);

  const AllMembersMenuContent = () => {
    return (
      <ul className="portfolio_report_container">
        <ModalFamily
          setSelectedMemberForReports={(id) => {
            // Determine the investment type (0-Domestic/1-Global/2-Combined)
            // allowed for the newly selected member.
            const offshoreValue =
              id !== "All"
                ? id.isoffshore
                : UserStore.userData.isoffshorefamily;

            const selectedReportType = reportTypeOptions.type.apiValue; // Previously selected report type
            const newSelectedReportType = offshoreValue; // Allowed report type for the newly selected member

            // Retain the current report type and denomination when:
            // 1. Both members support the same investment type, or
            // 2. The newly selected member supports Combined investments.
            // In these cases, only update the isCombined flag.
            if (
              newSelectedReportType === 2 ||
              newSelectedReportType === selectedReportType
            ) {
              setReportTypeOptions((prev) => ({
                ...prev,
                isCombined: offshoreValue === 2,
              }));
            } else {
              // Clear denomination data since the selected member
              // does not support the previously selected investment type.
              ReportsStore.setReportsData("allDenominations", {});

              // Reset the report type to one supported by the newly
              // selected member and update the combined flag.
              setReportTypeOptions((prev) => ({
                ...prev,
                type: portfolioReportValues[offshoreValue],
                isCombined: offshoreValue === 2,
              }));

              // Fetch denominations for the newly selected report type
              // and set the first denomination as the default selection.
              ReportsStore.getDenominations({
                isOffshore: offshoreValue,
                isUpdateFilter: false,
                onSuccess: ({ data }) => {
                  setDenomination(data[0]);
                },
              });
            }
            setSelectedMember(id);
            setAllMembersMenuOpen(false);
          }}
          selectedMemberForReports={selectedMember}
          showResetAndSubmit={false}
          searchBarWidth="350px"
          isSort={isSort}
          setSort={setSort}
          aToZclassName={"aToZclassName"}
          searchBtnClassName={"modal_family_search_button"}
        />
      </ul>
    );
  };

  const getAccountsList = () => {
    if (
      UserStore?.selectedClientId !== "0" &&
      getCookie("isPrimary") === "false"
    ) {
      return ReportsStore?.allAccountsData?.[
        UserStore?.selectedClientId
      ]?.flat();
    } else {
      if (selectedMember === "All") {
        if (ReportsStore?.allAccountsData) {
          return Object?.values(ReportsStore?.allAccountsData)?.flat();
        }
      } else {
        return ReportsStore?.allAccountsData?.[selectedMember?.user_id];
      }
    }
  };

  // const ReportMenu = ({ report, onClick, reportTypekey, className }) => {
  //   return (
  //     <li className={className} onClick={() => onClick(report)}>
  //       <div className="radio_btn_input" onClick={() => onClick(report)}>
  //         {report.key === reportTypekey ? <FilledButton /> : <EmptyButton />}
  //       </div>
  //       <label className="radio_btn_label " for={report.key}>
  //         <OverflowingText
  //           text={report?.name || "Not Selected"}
  //           width={160}
  //           textClassName="radio_btn_label cursor_imp"
  //           tooltipOnHover={true}
  //           position="left"
  //           tooltipClassName="accounts_tooltip_styles"
  //         />
  //       </label>
  //     </li>
  //   );
  // };

  // const ReportTypeMenu = () => {
  //   const handleChange = (report) => {
  //     // when first request is in pending state,and user selects other option at the same time , then the first request will get cancelled
  //     if (reportTypeRef.current) reportTypeRef.current.abort();

  //     const reportRef = new AbortController();
  //     reportTypeRef.current = reportRef;

  //     // set report type
  //     setReportTypeOptions((prev) => ({
  //       ...prev,
  //       //isOpen: false,
  //       type: { ...report },
  //     }));

  //     // We are storing denominations array in an object and its keys are global values that we get from api
  //     // { 0 : [...denominations] , 1 : [...denominations] , 2 : [...denominations] }
  //     // If any denomination is not present then we call the get api for the denomination
  //     // else we will not call api for that denomination and will show the already present data from the object
  //     if (!ReportsStore.allDenominations[report.apiValue]) {
  //       ReportsStore.getDenominations({
  //         isOffshore: report.apiValue,
  //         isUpdateFilter: false,
  //         onSuccess: ({ data }) => {
  //           setDenomination(data[0]);
  //         },
  //         reportRef,
  //       });
  //     } else {
  //       setDenomination(ReportsStore.allDenominations[report.apiValue][0]);
  //       ReportsStore.setReportsData("isFetchingDenominations", false);
  //     }
  //   };

  //   return (
  //     <ul className="portfolio_report_accounts_container portfolio_report ul-list">
  //       {portfolioReportType?.map((report) => {
  //         const isClickable =
  //           reportTypeOptions.isCombined ||
  //           ReportsStore.allDenominations[report.apiValue];

  //         return isClickable ? (
  //           <ReportMenu
  //             report={report}
  //             reportTypekey={reportTypeOptions?.type?.key}
  //             onClick={(report) => handleChange(report)}
  //             className={"account_listitem cursor"}
  //           />
  //         ) : (
  //           <ReportMenu
  //             report={report}
  //             onClick={() => {}}
  //             reportTypekey={reportTypeOptions?.type?.key}
  //             className={"account_listitem cursor_block"}
  //           />
  //         );
  //       })}
  //     </ul>
  //   );
  // };

  // const AllAccountsMenuContent = () => {
  //   const handleChange = (account) => {
  //     setSelectedAccount(account);
  //     setAllAccountsMenuOpen(false);
  //   };

  //   return (
  //     <ul className="portfolio_report_accounts_container">
  //       <li className="account_listitem" onClick={() => handleChange("All")}>
  //         <div
  //           className="radio_btn_input cursor"
  //           onClick={() => handleChange("All")}
  //         >
  //           {selectedAccount === "All" ? <FilledButton /> : <EmptyButton />}
  //         </div>
  //         <label className="radio_btn_label cursor">All Accounts</label>
  //       </li>
  //       {getAccountsList()?.map((accountData) => (
  //         <li
  //           className="account_listitem cursor"
  //           onClick={() => handleChange(accountData)}
  //         >
  //           <div
  //             className="radio_btn_input"
  //             onClick={() => handleChange(accountData)}
  //           >
  //             {accountData.account_Code === selectedAccount.account_Code ? (
  //               <FilledButton />
  //             ) : (
  //               <EmptyButton />
  //             )}
  //           </div>
  //           <label
  //             className="radio_btn_label cursor"
  //             for={accountData.account_Code}
  //           >
  //             <OverflowingText
  //               text={accountData?.account_Name}
  //               width={160}
  //               textClassName="radio_btn_label cursor_imp"
  //               tooltipOnHover={true}
  //               position="left"
  //               tooltipClassName="accounts_tooltip_styles"
  //             />
  //           </label>
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  // const AcquisitionDateMenuContent = () => {
  //   const handleChange = (dateSelection) => {
  //     setSelectedAcquisitionDate(dateSelection);
  //     setAcquisitionDateMenuOpen(false);
  //   };

  //   const trasnfArr = ["Transfer-In Date", "Inception Date"];
  //   const inceptionArr = ["Inception Date", "Transfer-In Date"];

  //   return (
  //     <ul className="portfolio_report_accounts_container">
  //       {(UserStore.usersData !== "(Inception)"
  //         ? [...trasnfArr]
  //         : [...inceptionArr]
  //       )?.map((dateSelection) => (
  //         <li
  //           className="account_listitem cursor"
  //           onClick={() => handleChange(dateSelection)}
  //         >
  //           <div
  //             className="radio_btn_input"
  //             onClick={() => handleChange(dateSelection)}
  //           >
  //             {dateSelection === selectedAcquisitionDate ? (
  //               <FilledButton />
  //             ) : (
  //               <EmptyButton />
  //             )}
  //           </div>
  //           <label className="radio_btn_label cursor" for={dateSelection}>
  //             {dateSelection}
  //           </label>
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  useEffect(() => {
    if (UserStore.isHydrated) {
      window.scrollTo(0, 0);
      setLoading(false);
      AuthStore.updateLoadingFullScreen(true);
      ReportsStore.populateReportsData("portfolio");
      setSelectedAcquisitionDate(
        UserStore.usersData !== "(Inception)"
          ? "Transfer-In Date"
          : "Inception Date",
      );
      const resetFilterToDefaultState = () => {
        UserStore.portfolioReportFilter = {
          timePeriod: "current_month",
          denomination: {},
          selectedMember:
            (getDecodedToken()?.user_type === "employee" ||
              getDecodedToken()?.user_type === "customer") &&
            UserStore.selectedClientId === "0"
              ? "All"
              : selectedMember !== "All"
                ? selectedMember
                : UserStore.portfolioReportFilter.selectedMember,
          selectedAccount: "All",
          selectedSection: [1, 3],
        };
      };
      return () => {
        setTimeout(() => {
          // Change the filters to defaut state on page change
          resetFilterToDefaultState();
          ReportsStore.setReportsData("allDenominations", {});
        }, 10);
      };
    }
    // eslint-disable-next-line
  }, [UserStore.isHydrated]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      if (
        (getDecodedToken()?.user_type === "customer" &&
          getDecodedToken().primary === "true") ||
        (getDecodedToken()?.user_type === "employee" &&
          UserStore.userData?.isprimary)
      ) {
        if (selectedMember === "All") {
          setSelectedAccount("All");
        } else {
          setSelectedAccount("All");
        }
      }
    }
  }, [
    selectedMember,
    userHydrated,
    // UserStore.isHydrated
  ]);

  const handleCheckboxChange = ({ checked, sectionId }) => {
    if (checked && Checkboxes.length === 1) {
      setCheckBoxes([1, 3]);
      return;
    }
    if (!checked) {
      setCheckBoxes((prev) => {
        return [...prev, sectionId];
      });
    } else {
      setCheckBoxes((prev) =>
        prev.filter((eachSectionId) => !(sectionId === eachSectionId)),
      );
    }
  };

  const handleEmailREport = () => {
    const userType = getDecodedToken()?.user_type;

    if (userType !== "employee") {
      sendEmail("btn", reportTypeOptions);
      return;
    } else setIsSendingMail(false);
    return setEmailReportToOpen(true);
  };

  const handleClickOnReportOption = (key) => {
    navigate(`/reports/${key}`, { state: { from: key } });
  };
  useEffect(() => {
    if (UserStore.isHydrated) {
      let as_of_date = getAsOfDate(UserStore.asOfDate);
      const asOfDate = getCookie("asOfDate");
      if (!getAsOfDate(UserStore.asOfDate) && asOfDate) as_of_date = asOfDate;
      const dateObjofAsOfDate = new Date(as_of_date);
      let newFromdate;
      let newTodate;
      let formattedFromdate;
      let formattedTodate;
      const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
      const quarterStartDate = new Date(
        dateObjofAsOfDate.getFullYear(),
        currentQuarter * 3,
      );
      if (!resetedFromDate && !resetedToDate) {
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth(),
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        setResetedFromDate(convertDateToObj(formattedFromdate));
        setResetedToDate(convertDateToObj(as_of_date));
      }
      switch (timePeriod) {
        case "current_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth(),
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth() - 1,
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          let dummyDateObj = new Date(as_of_date);
          let dummyTime = dummyDateObj?.setDate(1);
          newTodate = new Date(dummyTime - oneDayDif);
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            3,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 2
                : dateObjofAsOfDate.getFullYear() - 1
            }`,
            3,
            1,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            2,
            31,
          );
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_quarter":
          newFromdate = quarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_quarter":
          const currentQuarterStartDate = quarterStartDate;
          const currentQuarterEndDate = new Date(
            quarterStartDate.getFullYear(),
            quarterStartDate.getMonth() + 2,
            0,
          );
          const previousQuarterStartDate = new Date(
            currentQuarterStartDate.getFullYear(),
            currentQuarterStartDate.getMonth() - 3,
          );
          const previousQuarterEndDate = new Date(
            currentQuarterEndDate.getFullYear(),
            currentQuarterEndDate.getMonth() - 1,
            0,
          );
          newFromdate = previousQuarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = previousQuarterEndDate;
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [timePeriod, UserStore.isHydrated]);

  const getHeadingForMembers = (selectedMember) => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false")
    ) {
      return UserStore?.userData?.full_name;
    } else {
      if (selectedMember === "All") {
        return "All Members";
      } else {
        return selectedMember.full_name;
      }
    }
  };

  const checkAccountsDropdownDisabled = () => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false")
    ) {
      return false;
    } else {
      return selectedMember === "All";
    }
  };

  const handleClickToDownload = () => {
    const win = window.open("downloadportfolioReport", `_blank`);
    if (win != null) {
      win.focus();
    }
  };

  const getDateType = ({ data }) => {
    return data === "Transfer-In Date" ? "TransferIn" : "Inception";
  };

  const getReportTypeValue = ({ data }) => {
    return data === DOMESTIC ? "_Domestic" : data === OFFSHORE ? "_Global" : "";
  };

  const getFileName = () => {
    return `${getExcelPdfNamePortfolio(
      "NuvamaReport",
      selectedMember,
      selectedAccount,
    )}_${getCurrentDateAndTimeDDMMYYHHMM()}_POINT_${getDateType({
      data: selectedAcquisitionDate,
    })}${getReportTypeValue({ data: reportTypeOptions.type?.key })}`;
  };

  const downloadExcel = () => {
    ReportsStore.setEmaiSendStatus("excelDownloadStatus", "pending");
    let selectedUsers = null;
    const formattedFromDate = `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`;
    const formattedToDate = `${toDate?.year}-${toDate?.month}-${toDate?.date}`;
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false")
    ) {
      selectedUsers = UserStore.userData?.user_id;
    } else {
      if (selectedMember === "All") {
        selectedUsers = UserStore.currentFamilyMembers?.map((familyMember) => {
          return familyMember?.user_id;
        });
      } else {
        selectedUsers = selectedMember?.user_id;
      }
    }

    const obj = {
      Name: getNameForPortfolioReportExcel(selectedMember, selectedAccount),
      accountType: selectedAccount === "All" ? "CLIENT" : "ACCOUNT",
      memberCode:
        selectedAccount === "All"
          ? String(selectedUsers)
          : selectedAccount.account_Code,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      //denomination: denominationObject[denomination.denomination],
      denomination: denomination.denomination,
      loggedBy: String(getDecodedToken().user_id),
      cbFlagPromoterHolding: false,
      IsAcquisition: selectedAcquisitionDate === "Transfer-In Date" ? 0 : 1,
      IsOffshore: reportTypeOptions.type?.apiValue,
    };

    ReportsStore.downloadPortfolioExcel(obj, getFileName());
  };

  const sendEmail = (checker, selectedReportType) => {
    setIsSendingMail(true);
    let familyId;
    let selectedUsers = null;
    let selectedAccounts = null;

    if (
      getDecodedToken()?.user_type === "employee" ||
      getDecodedToken()?.user_type === "manager"
    ) {
      familyId = UserStore?.userData?.family_id;
    } else {
      familyId = getDecodedToken()?.family_id;
    }

    const isOffshore = selectedReportType.type?.apiValue;
    var reportLevels = 1;
    var reportType = "F";

    if (selectedMember !== "All") {
      if (selectedAccount === "All") {
        reportLevels = 2;
        reportType = "C";
      } else if (selectedAccount !== "All") {
        reportLevels = 3;
        reportType = "A";
      }
    }
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false")
    ) {
      selectedUsers = UserStore.userData?.user_id;
    } else {
      if (selectedMember === "All") {
        selectedUsers = UserStore.currentFamilyMembers?.map((familyMember) => {
          return familyMember?.user_id;
        })[0];
      } else {
        selectedUsers = selectedMember?.user_id;
      }
    }

    if (selectedAccount === "All") {
      selectedAccounts = 0;
    } else {
      selectedAccounts = selectedAccount.account_Code;
    }

    const getRecipantName = () => {
      switch (selectedUser) {
        case "clientEmail":
          return ReportsStore.emailIdDataForPortfolio?.["clientName"];
        case "rmEmail":
          return ReportsStore.emailIdDataForPortfolio?.["rmName"];
        case "csoEmail":
          return ReportsStore.emailIdDataForPortfolio?.["csoName"];
        case "selfEmail":
          return ReportsStore.emailIdDataForPortfolio?.["selfName"];
        default:
          break;
      }
    };

    const time = "T00:00:00+05:30";
    const formattedFromDate = `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}${time}`;
    const formattedToDate = `${toDate?.year}-${toDate?.month}-${toDate?.date}${time}`;
    const payload = {
      FAMILY_CODE: familyId,
      CLIENT_CODE: String(selectedUsers),
      ACCOUNT_CODE: selectedAccounts,
      FROM_DATE: formattedFromDate,
      TO_DATE: formattedToDate,
      DENOMINATION: denomination.denomination,
      SECTIONS: Checkboxes.join(","),
      REPORT_TYPE: reportType,
      REPORT_LEVEL: reportLevels,
      PROMOTERHOLDING: 1,
      CREATED_DATE: new Date().toISOString().split("T")[0],
      CREATED_BY: String(getDecodedToken().user_id),
      ToEMAIL: checker
        ? ReportsStore.emailIdDataForPortfolio?.[selectedUser]
        : "",
      RecipientName: checker ? getRecipantName() : "",
      checker,
      IsAcquisition: selectedAcquisitionDate === "Transfer-In Date" ? 0 : 1,
      IsOffshore: isOffshore,
    };
    if (!checker) {
      const fileName = getFileName();

      ReportsStore.setPortfolioReportObj(payload);
      setCookie("portfolioReportPayload", { ...payload, fileName });
      ReportsStore.setFileNamePortfolio(fileName);
      handleClickToDownload();
    } else {
      ReportsStore.getPortfolioReports({
        checker,
        payload,
        onSuccess: () => {
          setEmailReportToOpen(false);
          if (checker) {
            setEmailReportSuccessOpen(true);
          }
          if (emailReportToOpen) {
            setEmailReportToOpen(false);
          }
        },
        fileName: getFileName(),
      });
    }
  };
  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  useEffect(() => {
    if (datePickerModalOpen && UserStore.isHydrated) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen, UserStore.isHydrated]);

  const setAsOfDateToLocalStorage = () => {
    if (getAsOfDate(UserStore.asOfDate)) {
      setCookie("asOfDate", getAsOfDate(UserStore.asOfDate));
    }
  };
  useEffect(() => {
    trackEventWithScreen({ eventName: REPORTS_PAGE, screenName: PORTFOLIO });
    logEvents(REPORTS_PAGE, {
      screenName: PORTFOLIO,
    });
    setAsOfDateToLocalStorage();
    return () => {
      setTimeout(() => {
        ReportsStore.updateAllAccountToDefault();
      }, 10);
    };
  }, []);

  const handleTabKeyPress = (event) => {
    const loaderElem = loaderRef.current;
    //add any focusable HTML element you want to include to this string
    const focusableElements = loaderElem.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (event.key === "Tab") {
      const focusableElementsArray = Array.from(focusableElements);
      const focusedIndex = focusableElementsArray.indexOf(
        document.activeElement,
      );

      if (event.shiftKey) {
        // Shift + Tab pressed
        if (focusedIndex === 0) {
          event.preventDefault();
          focusableElementsArray[focusableElementsArray.length - 1].focus();
        }
      } else {
        // Tab pressed
        if (focusedIndex === focusableElementsArray.length - 1) {
          event.preventDefault();
          focusableElementsArray[0].focus();
        }
      }
    }
  };

  useEffect(() => {
    // If tab key is pressed on loading screen
    if (ReportsStore.excelDownloadStatus === "pending") {
      const loaderElem = loaderRef.current;
      if (loaderElem) {
        loaderElem.focus();
        loaderElem.addEventListener("keydown", handleTabKeyPress);

        return () => {
          loaderElem.removeEventListener("keydown", handleTabKeyPress);
        };
      }
    }
  }, [ReportsStore.excelDownloadStatus, loaderRef.current]);

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Portfolio Report"} />
          {loading ||
          AuthStore.isLoadingFullScreen ||
          !UserStore.isHydrated ||
          !ReportsStore.allSections ? (
            <LoadingScreen />
          ) : (
            <>
              {ReportsStore.excelDownloadStatus === "pending" && (
                <div className="loader_container_excel">
                  <div></div>
                  <div tabIndex={0} ref={loaderRef}>
                    <img
                      tabIndex={0}
                      className="loader_gif"
                      src={loaderGIF}
                      alt="loading..."
                    />
                  </div>
                </div>
              )}
              <Header type="reports" />
              <div className="reports_outer_main">
                <PageHeading
                  headingClass="head"
                  headingText="Portfolio Report"
                />
                <div className="reports_yellow_container">
                  <div className="first_container">
                    <div className="time_period_container">
                      <RadioGroup
                        heading="Time Period"
                        name="time_period"
                        radioBtnArray={timePeriodRadioBtnsData}
                        handleChange={handleTimePeriodChange}
                        value={timePeriod}
                        radioBtnsPerRow={4}
                        groupId={"portfolio-time-period"}
                        groupName={"portfolio-radio-group1"}
                        isDisabled={false}
                      />
                      <DatePicker2
                        handleReset={handleTimePeriodReset}
                        timePeriod={timePeriod}
                        fromDate={
                          fromDate
                            ? fromDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        toDate={
                          toDate
                            ? toDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        initialFromDate={initialFromDate}
                        initialToDate={initialToDate}
                        resetedFromDate={resetedFromDate}
                        resetedToDate={resetedToDate}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        isActive={true}
                        open={datePickerModalOpen}
                        setOpen={() => {
                          handleTimePeriodChange("custom");
                          setDatePickerModalOpen(true);
                        }}
                        onClose={() => setDatePickerModalOpen(false)}
                        buttonClass=""
                      />
                    </div>
                    <div className="denomination_container">
                      <div className="report-type">
                        <h2>Select Report</h2>

                        {/* <GoldenDropDown
                          heading={reportTypeOptions.type.name}
                          ReportMenuContent={ReportTypeMenu}
                          showPopup={
                            reportTypeOptions.type.key !== NOTRANSACTION
                          }
                          reportsMenuOpen={isReportTypeMenuOpen}
                          setReportsMenuOpen={setIsReportTypeMenuOpen}
                          position={{ top: "56px", left: "0px" }}
                          showArrow={false}
                          dropDownContainerClass="all_accounts_dropdown"
                          popupMenuClass="tooltip-overflow"
                        /> */}

                        <ReportTypeDropdown
                          heading={reportTypeOptions.type.name}
                          headingValue={reportTypeOptions}
                          reportTypeOptions={reportTypeOptions}
                          allDenomination={ReportsStore.allDenominations}
                          setHeadingValue={(report) => {
                            // when first request is in pending state,and user selects other option at the same time , then the first request will get cancelled
                            if (reportTypeRef.current)
                              reportTypeRef.current.abort();

                            const reportRef = new AbortController();
                            reportTypeRef.current = reportRef;

                            // set report type
                            setReportTypeOptions((prev) => ({
                              ...prev,
                              //isOpen: false,
                              type: { ...report },
                            }));

                            // We are storing denominations array in an object and its keys are global values that we get from api
                            // { 0 : [...denominations] , 1 : [...denominations] , 2 : [...denominations] }
                            // If any denomination is not present then we call the get api for the denomination
                            // else we will not call api for that denomination and will show the already present data from the object
                            if (
                              !ReportsStore.allDenominations[report.apiValue]
                            ) {
                              ReportsStore.getDenominations({
                                isOffshore: report.apiValue,
                                isUpdateFilter: false,
                                onSuccess: ({ data }) => {
                                  setDenomination(data[0]);
                                },
                                reportRef,
                              });
                            } else {
                              setDenomination(
                                ReportsStore.allDenominations[
                                  report.apiValue
                                ][0],
                              );
                              ReportsStore.setReportsData(
                                "isFetchingDenominations",
                                false,
                              );
                            }
                          }}
                          setCustomIndex={({ index }) => {
                            const selectedDataIndex =
                              portfolioReportType?.findIndex(
                                (data) =>
                                  data.key === reportTypeOptions.type.key,
                              );
                            return {
                              selectedIndex: selectedDataIndex,
                              focusedIndex: selectedDataIndex,
                            };
                          }}
                          position={{ top: "56px", left: "0px" }}
                          showArrow={false}
                          showPopup={
                            reportTypeOptions.type.key !== NOTRANSACTION
                          }
                          disabledPopup={false}
                          isDisabled={false}
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass:
                              "all_accounts_dropdown ugl-report",
                            popupMenuClass: "tooltip-overflow",
                          }}
                          restrictHover={true}
                          OPTIONS={portfolioReportType}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "radiogroup",
                            ariaControls: "report-type-options",
                            ariaLabel: "Report Type",
                          }}
                        />
                      </div>
                      <RadioGroup
                        heading="Select Denomination"
                        name="select_denomination"
                        radioBtnArray={
                          ReportsStore.allDenominations?.[
                            reportTypeOptions.type?.apiValue
                          ]
                        }
                        handleChangeReturnEvent={true}
                        handleChange={handleDenominationChange}
                        value={denomination?.denomination}
                        isLoading={ReportsStore.isFetchingDenominations}
                        containerClass={`all_radio_btns ${
                          !ReportsStore.isFetchingDenominations
                            ? "portfolio_container"
                            : "portfolio_loader"
                        }`}
                        groupId={"portfolio-denomination"}
                        groupName={"portfolio-radio-group2"}
                      >
                        {/* show skeleton loader when denomination values are being fetched from api */}
                        <div className="portfolio-radio-loader">
                          <Skeleton height={"30px"} width={"120px"} />
                          <Skeleton height={"30px"} width={"120px"} />
                          <Skeleton height={"30px"} width={"120px"} />
                        </div>
                      </RadioGroup>
                      <div className="dropdown_container portfolio_report_dropdowns filters">
                        <GoldenDropDown
                          heading={getHeadingForMembers(selectedMember)}
                          selectedMember={selectedMember}
                          showPopup={
                            getDecodedToken()?.user_type === "manager" ||
                            (getDecodedToken()?.user_type === "employee" &&
                              UserStore?.selectedClientId !== "0") ||
                            (getDecodedToken()?.user_type === "customer" &&
                              getDecodedToken()?.primary === "false") ||
                            UserStore?.selectedClientId !== "0"
                              ? false
                              : true
                          }
                          popupMenuClass="reports_select_family_member_popup_menu"
                          ReportMenuContent={AllMembersMenuContent}
                          reportsMenuOpen={allMembersMenuOpen}
                          setReportsMenuOpen={setAllMembersMenuOpen}
                          position={{
                            top: "57px",
                            left: "0px",
                            minWidth: 380,
                          }}
                          showArrow={false}
                          dropDownContainerClass="all_members_dropdown blueDropdownBorder"
                        />

                        <AccountsDropDown
                          heading={
                            selectedAccount !== "All"
                              ? selectedAccount.account_Name
                              : "All Accounts"
                          }
                          headingValue={selectedAccount}
                          setHeadingValue={(data) => {
                            setSelectedAccount(data);
                          }}
                          position={{ top: "56px", left: "0px" }}
                          showPopup={true}
                          showArrow={false}
                          // disabledPopup={
                          //   ReportsStore.usersAccounts.length === 1
                          // }
                          isDisabled={checkAccountsDropdownDisabled()}
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass:
                              "all_accounts_dropdown blueDropdownBorder",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={[
                            {
                              account_Code: "All",
                              account_Name: "All Accounts",
                            },
                          ].concat(getAccountsList())}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "radiogroup",
                            ariaControls: "accounts-options",
                            ariaLabel: "Accounts Selection",
                          }}
                          dataKey="account_Code"
                          dataValueKey="account_Name"
                        />

                        <AcquisitionDateTypeDropdown
                          heading={selectedAcquisitionDate}
                          headingValue={selectedAcquisitionDate}
                          setHeadingValue={(data) =>
                            setSelectedAcquisitionDate(data)
                          }
                          position={{
                            top: "56px",
                            left: "0px",
                            minWidth: "180px",
                            width: "fit-content",
                          }}
                          showArrow={false}
                          // disabledPopup={selectedStocks?.nodata}
                          // isDisabled={
                          //   ReportsStore?.unrealisedReportFilter?.selectedAssetClass
                          //     ?.className === "No Asset Class" ||
                          //   !selectedInvestmentType?.className
                          // }
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass:
                              "all_accounts_dropdown blueDropdownBorder",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={
                            UserStore.usersData !== "(Inception)"
                              ? [...trasnfArr]
                              : [...inceptionArr]
                          }
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "radiogroup",
                            ariaControls: "date-type-options",
                            ariaLabel: "Date Type",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="second_container">
                    <div className="selection_container">
                      <p className="checkbox_group_heading">Select Section</p>
                      <div className="checkbox_selection_wrapper">
                        {/* {ReportsStore.allSections?.map((eachCheckbox) => (
                          <div
                            className="each_checkbox_container cursor"
                            onClick={() =>
                              handleCheckboxChange({
                                checked: Checkboxes?.includes(eachCheckbox.id),
                                sectionId: eachCheckbox.id,
                              })
                            }
                          >
                            <input
                              checked={Checkboxes?.includes(eachCheckbox.id)}
                              name={eachCheckbox.id}
                              className="checkbox"
                              type="checkbox"
                            />
                            <p>{eachCheckbox.section}</p>
                          </div>
                        ))} */}
                        {ReportsStore.allSections?.map((eachCheckbox) => {
                          const isChecked = Checkboxes?.includes(
                            eachCheckbox.id,
                          );

                          return (
                            <label
                              key={eachCheckbox.id}
                              className={`each_checkbox_container cursor ${
                                isChecked
                                  ? "checked checkbox-checked darkBlueTextColor"
                                  : ""
                              }`}
                            >
                              <input
                                type="checkbox"
                                className="checkbox"
                                checked={isChecked}
                                onChange={() => {
                                  handleCheckboxChange({
                                    checked: isChecked,
                                    sectionId: eachCheckbox.id,
                                  });
                                }}
                              />
                              <span className="label_text">
                                {eachCheckbox.section}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="two_blue_buttons_container">
                    {/* Disable click when denomination values are being fetched from api */}
                    <BlueButton
                      icon={<PdfFilledWhite />}
                      text="Export to PDF"
                      onClick={() => {
                        if (!ReportsStore.isFetchingDenominations) {
                          sendEmail("", reportTypeOptions);
                          ReportsStore.setDownloadTrigger([
                            ...ReportsStore.downloadTrigger,
                            {},
                          ]);
                        }
                      }}
                    />
                    <BlueButton
                      icon={<ExcelFilledWhite />}
                      text="Export to Excel"
                      onClick={() => {
                        if (!ReportsStore.isFetchingDenominations) {
                          if (window.confirm(portfolioReportMsg))
                            downloadExcel();
                        }
                      }}
                    />

                    <BlueButton
                      icon={<EmailFilledWhite />}
                      text="Email Report"
                      onClick={() => {
                        if (!ReportsStore.isFetchingDenominations) {
                          handleEmailREport();
                        }
                      }}
                    />
                  </div>
                  <Modal
                    onClose={() => setEmailReportSuccessOpen(false)}
                    open={emailReportSuccessOpen}
                    title={"Report Sent"}
                    width={"497px"}
                    showCloseIcon={true}
                  >
                    <EmailReportSuccessContent />
                  </Modal>
                  <Modal
                    onClose={() => setEmailReportToOpen(false)}
                    open={emailReportToOpen}
                    title={"Email Report to"}
                    width={"810px"}
                    showCloseIcon={true}
                  >
                    {EmailReportToContent}
                  </Modal>
                </div>
                <div className="view_other_reports_notes_container">
                  {selectedAcquisitionDate === "Inception Date" && (
                    <ul className="tax_report_notes notes">
                      <li>
                        <span></span>
                        The information provided in these reports would be as
                        per best available data provided
                      </li>
                      <li>
                        <span></span>
                        The Inception Date provided would be for Equity, Mutual
                        Fund and Bond asset classes and not for PMS
                      </li>
                      <li>
                        <span></span>
                        If Inception Date not present then the report generated
                        would be on the basis of Transfer-in date
                      </li>
                      <li>
                        <span></span>
                        Interest/Dividend related details would not be provided
                        for the Inception Date data
                      </li>
                    </ul>
                  )}
                  <div className="view_other_reports_container">
                    <div className="view_other_reports_text">
                      Also View <span>other Reports </span>
                    </div>
                    <div className="other_reports_wrapper">
                      <div
                        className="other_report_card"
                        onClick={() =>
                          handleClickOnReportOption("transactions-report")
                        }
                      >
                        <img src={transectionReportIcon} alt="" />
                        <p>Transaction Report</p>
                      </div>
                      <div
                        className="other_report_card"
                        onClick={() => handleClickOnReportOption("tax-report")}
                      >
                        <img src={taxReportIcon} alt="" />
                        <p>Tax Report</p>
                      </div>
                      <div
                        className="other_report_card"
                        onClick={() =>
                          handleClickOnReportOption(
                            "unrealised-gain-loss-report",
                          )
                        }
                      >
                        <img src={unrealisedReportIcon} alt="" />
                        <p>Unrealised Gain/Loss Report</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <Modal
            modalStyle={{
              padding: "25px 25px 33px",
            }}
            showCloseIcon={true}
            open={UserStore?.portfolioReportDownloadError === 500}
            onClose={() => {
              UserStore.setTaxReportDownloadError(false);
              UserStore.setPortfolioReportDownloadError(false);
            }}
          >
            <div className="home_popup_container">
              <svg
                width="50"
                height="49"
                viewBox="0 0 50 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.9842 48.5214C23.6646 48.5214 22.4421 47.9259 21.6287 46.8858L16.7344 40.679L8.15511 40.6737C3.93446 40.6737 0.5 37.2393 0.5 33.0175V8.03905C0.5 3.81728 3.93446 0.382812 8.15623 0.382812H41.8437C46.0654 0.382812 49.4999 3.81728 49.4999 8.03905V23.4472C49.4999 24.5044 48.6431 25.3613 47.5858 25.3613C46.5286 25.3613 45.6718 24.5044 45.6718 23.4472V8.03905C45.6718 5.92835 43.9544 4.21093 41.8437 4.21093H8.15623C6.04554 4.21093 4.32812 5.92835 4.32812 8.03905V33.0175C4.32812 35.1282 6.04554 36.8456 8.15623 36.8456L17.6645 36.8512C18.2503 36.8516 18.8036 37.1204 19.1662 37.5802L24.6396 44.5213C24.7513 44.6645 24.8878 44.6933 24.9846 44.6933H24.9865C25.0829 44.6929 25.2205 44.6634 25.3274 44.5247C25.3308 44.5202 25.3342 44.5157 25.3375 44.5116L30.7664 37.5795C31.1294 37.1163 31.6849 36.8456 32.2734 36.8456H41.8437C43.9547 36.8456 45.6718 35.1282 45.6718 33.0175C45.6718 31.9603 46.5286 31.1035 47.5858 31.1035C48.6431 31.1035 49.4999 31.9603 49.4999 33.0175C49.4999 37.2393 46.0654 40.6737 41.8437 40.6737H33.2057L28.3555 46.8664C27.5465 47.9132 26.3248 48.5162 25.0014 48.5214C24.9958 48.5214 24.9899 48.5214 24.9842 48.5214ZM26.914 29.5722V19.2363C26.914 18.1791 26.0572 17.3222 25 17.3222C23.9427 17.3222 23.0859 18.1791 23.0859 19.2363V29.5722C23.0859 30.6294 23.9427 31.4863 25 31.4863C26.0572 31.4863 26.914 30.6294 26.914 29.5722ZM25 10.7187C23.9427 10.7187 23.0859 11.5756 23.0859 12.6328C23.0859 13.69 23.9427 14.5468 25 14.5468C26.0572 14.5468 26.914 13.69 26.914 12.6328C26.914 11.5756 26.0572 10.7187 25 10.7187Z"
                  fill="#E12014"
                />
              </svg>
              <p className="home_popup_info_text">
                Something went wrong, Please try again after sometime.
              </p>
              <div className="home_page_popup_arrow_btn">
                <ArrowButton
                  onClick={() => {
                    UserStore.setPortfolioReportDownloadError(false);
                  }}
                  type={"next"}
                  label={"Got it"}
                  styleProp={{
                    borderRadius: "15px",
                  }}
                />
              </div>
            </div>
          </Modal>
        </div>
      )}
    </Observer>
  );
});

export default PortfolioReport;
